var inputLeft = document.getElementById("input-left");
var inputRight = document.getElementById("input-right");

var thumbLeft = document.querySelector(".slider > .thumb.left");
var thumbRight = document.querySelector(".slider > .thumb.right");
var range = document.querySelector(".slider > .range");

var rangeValueLeft = document.getElementById('range-value-left');
var rangeValueRight = document.getElementById('range-value-right');

function setLeftValue() {
	var _this = inputLeft,
		min = parseInt(_this.min),
		max = parseInt(_this.max);

	_this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 0);

	var percent = ((_this.value - min) / (max - min)) * 100;

	thumbLeft.style.left = percent + "%";
	range.style.left = percent + "%";

    rangeValueLeft.innerHTML = inputLeft.value;
}

function setRightValue() {
	var _this = inputRight,
		min = parseInt(_this.min),
		max = parseInt(_this.max);

	_this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 0);

	var percent = ((_this.value - min) / (max - min)) * 100;

	thumbRight.style.right = (100 - percent) + "%";
	range.style.right = (100 - percent) + "%";

    rangeValueRight.innerHTML = inputRight.value;
}

if(inputLeft && inputRight && thumbLeft && thumbRight && range && rangeValueLeft && rangeValueRight) {

	setLeftValue();
	setRightValue();

	inputLeft.addEventListener("input", setLeftValue);
	inputRight.addEventListener("input", setRightValue);

	inputLeft.addEventListener("mouseover", function() {
		thumbLeft.classList.add("hover");
	});
	inputLeft.addEventListener("mouseout", function() {
		thumbLeft.classList.remove("hover");
	});
	inputLeft.addEventListener("mousedown", function() {
		thumbLeft.classList.add("active");
	});
	inputLeft.addEventListener("mouseup", function() {
		thumbLeft.classList.remove("active");
	});

	inputRight.addEventListener("mouseover", function() {
		thumbRight.classList.add("hover");
	});
	inputRight.addEventListener("mouseout", function() {
		thumbRight.classList.remove("hover");
	});
	inputRight.addEventListener("mousedown", function() {
		thumbRight.classList.add("active");
	});
	inputRight.addEventListener("mouseup", function() {
		thumbRight.classList.remove("active");
	});

}

// // Filters for publications
// let resetButton = document.querySelector('.reset_publications')

// resetButton?.addEventListener('click', function(){
//     //Reset range
// 	inputLeft.value = 1974;
// 	inputRight.value = new Date().getFullYear();
// 	setLeftValue();
// 	setRightValue();
// })

// Filters for publications
let resetButton = document.querySelector('.reset_publications')

resetButton?.addEventListener('click', function(){
    // Reset select year
    document.getElementById('year-select').value = '';
}) 